import { InfoService } from '../../interfaces/infoservice.interface';
import { constantes } from '../../constantes';
import { ParamsService } from '../../services/params.service';
import { DataService } from '../../services/data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-info',
  templateUrl: './page-info.component.html',
  styleUrls: ['./page-info.component.scss']
})
export class PageInfoComponent implements OnInit {
	
	
	msgError:string;
	constantes:any = constantes;
	filterFull:boolean;

  constructor(
		public dataService:DataService,
		private paramsService:ParamsService,
	) { }

  ngOnInit() {
		
		// this.dataService.resetSelectedSectorsInfos(this.constantes.sectors);
		this.filterFull = true;
	}
	
	
	
	clickSector(id:string){
		
		// debugger;
		if(id == 'all') this.dataService.resetSelectedSectorsInfos(this.constantes.sectors);
		else this.dataService.toggleSelectedSectorInfos(id);
		this.dataService.filterInfos(this.dataService.selectedSectorsInfos);
		
		this.filterFull = Object.values(this.dataService.selectedSectorsInfos).every(test => {
			if(test) return true;
			else return false;
		});
	}
	
	isEmpty():boolean
	{
		return this.dataService.infoServices && this.dataService.infoServices.length == 0;
	}
	
	
	
	onLocalize(item:InfoService):void
	{
		item.rubric = 'info-travaux';
		this.paramsService.dispatch('localize', item);
	}

}
